/**
 * 주소창 - 이 앱의 입구이자 개발 도구.
 *
 * 근거 문서: `이상한방-상태모델-v0.1.md` 9.4절
 *
 * ## URL이 곧 개발 도구다 (9.4절)
 *
 * 4주 계획의 병목은 코딩이 아니라 **반복 횟수**다. 그래서 주소창 하나로 원하는 지점에 떨어진다:
 *
 * | URL | 무엇 |
 * |---|---|
 * | `/` | 단계 선택 |
 * | `?level=7` | 7단계 **즉시 시작**(안내도 해금 검사도 건너뛴다) |
 * | `?seed=...` | 자유 모드 - 단계와 무관한 아무 방(튜닝 실험용) |
 * | `?level=3&attempt=2` | 3단계의 **3회차 변화 조합**. 방은 그대로, 변화만 그 시도의 것. 한 판에만 쓰이고 주소에서 지워진다 |
 * | `?level=3&hunt=30&ammo=99` | 단계 값 위에 URL 덮어쓰기. **URL이 이긴다** |
 * | `?mags=0` | 이번 세션의 보유 탄창 수. **0이 밸런스 대전제의 대조군이다**(`app/accountMagazines.ts`) |
 * | `?magAmmo=4` | 탄창 하나가 채우는 탄환 |
 * | `?magRound=1` | 한 라운드에서 쓸 수 있는 탄창 수 |
 * | `?cooldown=3` | 원래 방 재입장 쿨타임(초). 기본 5초가 맞는 값인지는 여기서만 잴 수 있다 |
 * | `?raiseMin=4` | 걸기(로드맵 M7)를 선언할 수 있는 최소 잔탄. 0이면 잔탄과 무관하게 걸 수 있는 대조군이다(`game/raise.ts`) |
 * | `?raiseCost=2` | 걸기 뒤 빗나감 한 발의 값(배수). 1이 하한 - 0이면 걸기 뒤 빗나감이 공짜다 |
 * | `?dev=1` | 배치(꾸미기) 모드를 연다. 없으면 게임 모드 하나뿐이다 |
 * | `?decorate=60&changeSec=60` | 매치의 꾸미기·바꾸기 길이(초). `?changes=`(개수)와 한 글자 차이라 `changeSec`이다. 전원이 이웃이거나 전원 끊긴 라운드는 바꾸기가 0이라 안 보인다 |
 * | `?perPlayer=3` | **인당** 이상한 곳 수(여럿이. 라운드 전체는 좌석 수 × 이 값 - `game/match/matchPhases.ts`) |
 * | `?changerPts=200` | 구획 점수 - 내 구획의 미발견 하나의 값(`game/match/matchScore.ts`) |
 * | `?sniped=1.5` | "OO이 먼저 찾았다" 피드백 창(초). 손해 0이라 규칙이 아니라 피드백만 바뀐다 |
 * | `?reserve=5` | 원래 방 차례 예약 유예(초). 0이면 차례를 놓치는 순간 다음 사람이다 |
 * | `?grace=60` | 재접속 유예(초, 로드맵 M6). 끊긴 뒤 이 안에 돌아오면 같은 좌석(탄환·발견 그대로)이다. 서버(`server/`)만 읽는다 - 서버는 URL이 없어 `TUNING` 기본값이고, 이 줄은 표의 완결성(`NUMERIC_SPECS`에 있는 키는 여기 적는다)을 위한 것이다 |
 * | `?botEvery=6&botFind=0.35&botMiss=0.25&botOrigin=0.1` | CPU 술래의 (N, p, q) + 원래 방 요청 확률(상태모델 9.1절). 봇 난이도는 이 넷을 재빌드 없이 돌려 잰다 |
 * | `?pins=500` | 이번 세션의 핀 수. `?mags=`와 같은 이유로 `Tuning` 밖이고 **저장을 건드리지 않는다** - 봉투 연출을 보려고 핀을 채운 세션이 진짜 보유량을 먹으면 사고다. 저장이 통째로 멈추므로 그 세션의 **사물함도 휘발한다**(준비물 소비·클리어 지급·꾸밈 장착이 새로고침에 되돌아온다 - `app/accountEconomy.ts`의 `commit`) |
 * | `?dev=1&date=2026-09-06` | 매일의 방이 믿는 오늘. **`?dev=1`이 함께 있어야 먹는다.** 저장을 건드리기 때문이다 - 이 날짜로 한 판을 끝내면 그날의 기록·연속 출석·핀이 실제로 남고, 날짜를 하루씩 밀며 반복하면 "하루 한 번"이 주소 한 줄로 무력화된다. 연속은 날이 바뀌어야 보이는 기능이라 검증에는 이 손잡이가 필요하지만, 배포된 페이지에는 문이 없어야 한다 |
 * | `?pull=3` | 봉투 3회차 연출을 다시 본다(`economy/envelope.ts`의 `replayDraw`). 저장의 회차도 핀도 움직이지 않는다. **이력에 남은 최근 20회차만 그대로**이고 그 밖은 바늘 자리만 같다(등급·피티는 모르므로 게이지를 감춘다) |
 * | `?match=bots` | 봇과 한 판(로드맵 M2) **직행**, 타이틀 없이. 단계 선택 화면의 "여럿이" 카드와 같은 문이다. 방은 `?seed=`(없으면 고정 기본값) |
 * | `?match=bots&bots=3` | 봇 수(1~7). 기본 3. 카드는 이 기본으로만 열고, 수를 바꾸는 길은 주소창뿐이다 |
 * | `?match=bots&botLevel=hard` | 봇 난이도(`easy` · `normal` · `hard`, `game/match/cpu.ts`). 기본 `normal`. (N, p, q) 자체는 `?botEvery=` 줄이 덮는다 |
 * | `?room=ABCD` | 여럿이 방(로드맵 M6) **직행**, 타이틀 없이. 서버가 발급한 네 글자 방 번호다. 이 탭이 그 방에 앉았던 기억(`app/netBoot.ts`)이 있으면 곧바로 자리로 돌아가고, 없으면 이름을 적는 로비가 선다. 방에 앉으면 주소창에 적히고, 나가면 지워진다 |
 *
 * `?level=3&hunt=30` 줄이 규약이다. 단계 값이 URL을 이기면 `?changes=1`로 단계를 검사할 수 없고,
 * 그 순간 `tuning.ts`가 내건 "재빌드 없이 바뀐다"가 단계 모드에서만 거짓이 된다.
 * 전체 키 목록과 허용 범위는 `game/tuning.ts`의 `NUMERIC_SPECS`가 원본이다 -
 * **수치 키는 여기서 읽지 않는다.** 이 파일이 읽는 것은 `tuning`에 담기지 않는 것뿐이다
 * (어느 판인가 · 몇 회차인가 · 봇과 몇 명인가 · 어느 방인가 · 도구를 여는가 · 이번 세션의 핀 · 재현할 봉투 회차, 그리고
 * `accountMagazines.ts`가 읽는 `?mags=`). 봇 수·난이도가 `Tuning` 밖인 이유는 그것이 라운드 규칙이 아니라 **방의 좌석**이기
 * 때문이다 - 서버 방(M6)에서는 로비가 정하는 값이고, `Tuning`에 넣으면 URL이 로비를 이기는 길이 생긴다. 핀과 봉투 회차가 `Tuning` 밖인 이유는 `?mags=`와 같다 -
 * 계정 저장에 사는 값을 튜닝에 섞으면 "저장값과 튜닝값 중 무엇이 진실인가"가 생긴다.
 *
 * ## 배치 모드는 플레이어의 기능이 아니다 (9.4절)
 *
 * 배치 에디터는 방을 만들어 보기 위한 **개발 도구**인데, 전환 버튼이 항상 떠 있는 동안에는
 * 수색 도중에도 한 번만 누르면 방을 뜯어볼 수 있었다 - 찾는 게임에서 정답을 여는 문이
 * 화면에 상시로 붙어 있었다는 뜻이다. 그래서 `?dev=1`이 없으면 도구 자체를 세우지 않는다.
 * 감추는 것이 아니라 만들지 않는 이유는, 감춘 도구는 언젠가 다시 드러나기 때문이다.
 * (실제로 세우지 않는 자리는 `app/stage.ts`의 `withEditor`, 버튼을 걷어 내는 자리는
 * `app/inputLayer.ts`다. 이 파일은 스위치를 읽기만 한다.)
 *
 * ## 읽기와 쓰기가 한 파일에 있는 이유
 *
 * 주소창은 **읽고 끝나는 값이 아니라 계속 맞춰 두는 값**이다. 판이 바뀔 때마다 지금 있는 곳으로
 * 갈아 끼우지 않으면 재현 가능한 유일한 판은 첫 판뿐이고, 시드 결정론을 지킨 의미가 절반 사라진다.
 * 그래서 "무엇을 읽었는가"와 "무엇을 적는가"의 규칙(단계와 시드는 서로를 지운다 · 첫 시도는
 * 적지 않는다 · `?dev=`는 지우지 않는다)이 같은 파일에 있어야 갈리지 않는다.
 */

import { isDateKey } from '../game/daily'
import { PIN_CAP } from '../game/economy/pins'
import { LEVEL_COUNT, getLevel } from '../game/levels'
import { BOT_DIFFICULTIES, type BotDifficulty } from '../game/match/cpu'
import { isRoomCode, normalizeRoomCode, ROOM_CODE_LENGTH } from '../net/protocol'

/**
 * 자유 모드 시드의 기본값.
 *
 * **`Math.random()`이나 `Date.now()`로 만들지 않는다.** 시드가 매번 달라지면
 * "이 방에서만 나는 버그"를 두 번 다시 볼 수 없고, 그 순간 시드는 재현 수단이 아니라 잡음이 된다.
 * "한 판 더"의 새 시드도 무작위가 아니라 이 값에서 **결정론적으로 파생**된다(`session.ts`의 `playAgain`).
 */
const DEFAULT_SEED = 'weird-room-01'
const SEED_QUERY_KEY = 'seed'
const LEVEL_QUERY_KEY = 'level'

/**
 * 시도 번호 쿼리. **방이 아니라 변화만 고른다**(`gameState.ts`의 시드 분리).
 *
 * 재도전은 같은 방에 매번 다른 변화를 얹으므로, 시드만으로는 "3회차에서만 나던 그 조합"을
 * 다시 부를 수 없다. 그 절반을 메우는 것이 이 파라미터다 - `?level=3&attempt=2`.
 */
const ATTEMPT_QUERY_KEY = 'attempt'

/** 첫 시도의 번호. 이 값이면 주소창에 쿼리를 남기지 않는다(기본값을 적어 두면 잡음이다). */
export const FIRST_ATTEMPT = 0

/**
 * 개발 도구 쿼리. 지금은 배치(꾸미기) 모드 하나를 여는 스위치다.
 *
 * 위의 `?level=`·`?seed=`와 달리 이것만은 **주소창에 남겨 둔다**(`clearLocationQuery`가 지우지 않는다).
 * 저 둘은 "어느 판인가"를 말하므로 화면을 옮기면 거짓이 되지만, 이건 "누가 보고 있는가"라
 * 화면과 무관하게 계속 참이다. 지웠다면 단계 선택으로 한 번 나올 때마다 도구가 닫힌다.
 */
const DEV_QUERY_KEY = 'dev'

/**
 * 이번 세션의 핀 수를 강제하는 쿼리. `?mags=`(`tuning.parseMagazineOverride`)와 같은 계약이다 -
 * 저장을 읽지도 쓰지도 않고 화면과 봉투가 이 값을 따른다. 주소에서 키를 지우면 원래 보유량이 그대로 돌아온다.
 */
const PINS_QUERY_KEY = 'pins'

/**
 * 재현할 봉투 회차. 연출을 다시 보기 위한 **개발 도구**라 저장의 회차를 움직이지 않는다.
 * 그 회차의 바늘 값은 계정 시드에서만 오므로 언제나 같다(`economy/envelope.ts` 머리말).
 */
const PULL_QUERY_KEY = 'pull'

/**
 * 매일의 방이 믿는 오늘(로드맵 M9). `app/dateKey.ts`의 시계를 덮어쓰는 유일한 길이다.
 *
 * **저장을 건드린다.** `?pins=`·`?mags=`가 저장을 읽지도 쓰지도 않는 것과 반대인데, 이유는 이 도구가
 * 재는 것이 화면이 아니라 **저장의 규칙**(연속 출석 · 첫 결과만)이기 때문이다. 저장을 비켜 가면
 * 검증할 것이 남지 않는다.
 *
 * 그래서 이것만은 `?dev=1` 뒤에 있다. 적어 두는 것과 막는 것은 다르다 - 날짜를 하루씩 밀며 매일의 방을
 * 반복 완주하면 연속과 핀이 실제로 쌓이고, 그건 "하루 한 번"이라는 이 기능의 전부를 주소 한 줄로 지운다.
 * 배치 에디터와 같은 판단이다(감추는 것이 아니라 문을 만들지 않는다).
 */
const DATE_QUERY_KEY = 'date'

/**
 * 봇과 한 판(로드맵 M2). `?match=bots`가 문이고 `?bots=`·`?botLevel=`이 그 판의 모양이다.
 *
 * 셋은 `?level=`·`?seed=`와 같은 계열("어느 판인가")이라 화면을 옮기면 거짓이 되고, 그래서 `clearLocationQuery`가 함께 지운다.
 * 시드는 따로 두지 않는다 - 방은 `?seed=`가 말한다. 시드가 둘이면 어느 것이 재현의 열쇠인지 갈린다(`app/stage.ts`의 `MatchStageRequest`).
 */
const MATCH_QUERY_KEY = 'match'
const BOTS_QUERY_KEY = 'bots'
const BOT_LEVEL_QUERY_KEY = 'botLevel'
/**
 * `?changer=me`(M4)는 M11에서 사라졌다 - 역할이 없어져 "내가 다녀간 사람인 판"이 곧 모든 판이다. 키만 남겨 두고
 * 여럿이 키를 지울 때 함께 지운다: 옛 링크가 남아 있으면 주소가 없는 손잡이를 가리킨 채로 있다.
 */
const LEGACY_CHANGER_QUERY_KEY = 'changer'

/** `?match=`의 유일한 값. 소켓 방(M6)은 `?room=CODE`라는 다른 문이다 - 이 키에 값을 더하지 않는다. */
const MATCH_BOTS = 'bots'

/**
 * 여럿이 방의 번호(로드맵 M6). `?match=bots`와 같은 계열("어느 판인가")이라 화면을 옮기면 거짓이 되고, 그래서 `clearLocationQuery`가
 * 함께 지운다. 코드의 원본은 서버(`server/src/roomCodes.ts`)라 여기서는 모양만 다듬는다 - 대문자 네 글자. 없는 방인지는 서버가 답한다.
 */
const ROOM_QUERY_KEY = 'room'
/**
 * 방 번호의 모양은 와이어 파일(`net/protocol.ts`)의 것이다 - 발급(서버) · 이 파서 · 로비 입력이 같은 알파벳과 길이를 봐야 한다.
 * 여기서 다시 적었더니 실제로 갈렸다: 이 파서만 `[A-Z0-9]`를 허용해 `?room=IO01`이 통과하고 서버에서 `no-room`이 됐다.
 */
export { ROOM_CODE_LENGTH }

/**
 * 봇 수의 기본과 상한. 기본 3은 로드맵 M2의 완료 판정("봇 3과 외우기 → …")이 쓰는 수이고, 카드도 이 수로만 연다.
 * 상한 7은 규칙이 아니라 화면이다 - 참가자 줄(`ui/playerStrip.ts`)이 여덟 칸(나 + 7)까지는 폰 세로에서 두 줄 안에 선다.
 */
export const DEFAULT_PARTY_BOTS = 3
export const MAX_PARTY_BOTS = 7
export const DEFAULT_BOT_LEVEL: BotDifficulty = 'normal'

/** `?match=bots`가 연 판의 모양. `seed`는 `?seed=`이거나 기본값이다 - 봇 판에는 무작위 시드가 없다(`DEFAULT_SEED` 주석). */
export type BotMatchRequest = Readonly<{
  seed: string
  bots: number
  botLevel: BotDifficulty
}>

/* --- 읽기 --------------------------------------------------------------------- */

/**
 * `?seed=`가 있으면 자유 모드 시드, 없으면 `null`(= 자유 모드 아님).
 *
 * **키의 유무와 값의 유효성을 갈라 본다.** `?seed=`(빈 값)는 "자유 모드로 가고 싶다"는 말이므로
 * 고정 기본값으로 떨어지고, 키가 아예 없는 것만 자유 모드가 아니다. 없는 값을 무작위로
 * 대체하지 않는 이유는 위 `DEFAULT_SEED` 주석에 있다.
 */
export function resolveFreeModeSeed(search: string): string | null {
  const params = new URLSearchParams(search)
  if (!params.has(SEED_QUERY_KEY)) return null

  const trimmed = params.get(SEED_QUERY_KEY)?.trim() ?? ''
  return trimmed === '' ? DEFAULT_SEED : trimmed
}

/**
 * `?level=7` → 7단계. 범위를 벗어나거나 숫자가 아니면 `null`(= 단계 직행 아님).
 *
 * **해금 검사를 하지 않는다.** 이 파라미터는 플레이어 기능이 아니라 개발 도구이고(9.4절),
 * 9단계 밀도를 확인하려고 매번 여덟 단계를 깨야 한다면 도구가 아니다.
 */
export function resolveLevelId(search: string): number | null {
  const raw = new URLSearchParams(search).get(LEVEL_QUERY_KEY)
  if (raw === null) return null

  const value = Number(raw.trim())
  if (!Number.isInteger(value) || getLevel(value) === undefined) {
    console.warn(`[main] ?${LEVEL_QUERY_KEY}=${raw} 무시됨 - 1~${LEVEL_COUNT} 범위의 단계가 아니다.`)
    return null
  }

  return value
}

/**
 * `?attempt=2` → 2. **없거나 잘못된 값이면 `null`**("지정하지 않았다") - 부르는 쪽이 기본값을 정한다.
 * 0을 돌려주지 않는 이유는 그 자리가 이제 저장된 판 수이기 때문이다(`progress.nextAttemptFor`) -
 * 여기서 0으로 접으면 "주소가 첫 판을 지정했다"와 "아무 말도 없었다"가 같은 값이 되어,
 * 다시 들어올 때마다 첫 회차의 정답표가 나온다.
 *
 * 해금 검사도 상한도 없다 - 이것은 `?level=`과 같은 계열의 **재현 도구**이고,
 * 시도 번호는 변화 시드의 일부일 뿐이라 어떤 값이 와도 결정론이 깨지지 않는다.
 */
export function resolveAttempt(search: string): number | null {
  const raw = new URLSearchParams(search).get(ATTEMPT_QUERY_KEY)
  if (raw === null) return null

  const value = Number(raw.trim())
  if (raw.trim() === '' || !Number.isSafeInteger(value) || value < FIRST_ATTEMPT) {
    console.warn(`[main] ?${ATTEMPT_QUERY_KEY}=${raw} 무시됨 - ${FIRST_ATTEMPT} 이상의 정수여야 한다.`)
    return null
  }

  return value
}

/**
 * `?dev=1` → 개발 도구를 연다. 없으면 닫힌 채로 간다.
 *
 * 값을 엄격하게 보지 않는 이유는 이게 **끄는 쪽이 기본**인 스위치이기 때문이다.
 * `?dev`나 `?dev=true`를 적은 사람의 의도는 하나뿐이고, 거기서 오타를 잡아 봐야
 * 도구가 안 열리는 이유를 콘솔에서 찾게 만들 뿐이다. 대신 끄는 표기는 분명히 인정한다.
 */
export function resolveDevTools(search: string): boolean {
  const raw = new URLSearchParams(search).get(DEV_QUERY_KEY)
  if (raw === null) return false

  const value = raw.trim().toLowerCase()
  return value !== '0' && value !== 'false' && value !== 'off'
}

/**
 * `?pins=500` → 500. 없거나 잘못된 값이면 `undefined`(= 강제 아님).
 *
 * 0을 허용한다 - "핀이 하나도 없는 사람"에게 [한 장 더]가 "N판이면 다시 연다"로 이유를 말하는지는
 * 이 값으로만 볼 수 있다. 상한은 저장과 같은 `PIN_CAP`이다. 잘못된 값은 `tuning.ts`의 규약대로
 * **무시하되 반드시 남긴다** - 값이 안 먹었는데 먹은 줄 알고 판단하면 그 판의 기록이 거짓이 된다.
 */
export function resolvePinsOverride(search: string): number | undefined {
  const raw = new URLSearchParams(search).get(PINS_QUERY_KEY)
  if (raw === null) return undefined

  const value = Number(raw.trim())
  if (raw.trim() === '' || !Number.isInteger(value) || value < 0 || value > PIN_CAP) {
    console.warn(`[main] ?${PINS_QUERY_KEY}=${raw} 무시됨 - 0~${String(PIN_CAP)}의 정수여야 한다.`)
    return undefined
  }

  return value
}

/**
 * `?date=2026-09-06` → 그 날짜 키. 없거나 날짜가 아니면 `null`(= 진짜 오늘을 쓴다).
 *
 * 판정은 `game/daily.isDateKey`가 한다 - 모양(`YYYY-MM-DD`)과 달력을 함께 보므로 `2026-02-30` 같은
 * 없는 날이 시드가 되지 않는다. 여기서 정규식을 새로 쓰면 날짜의 정의가 두 곳에 생긴다.
 */
export function resolveDateKeyOverride(search: string): string | null {
  const raw = new URLSearchParams(search).get(DATE_QUERY_KEY)
  if (raw === null) return null

  // 개발 도구가 아니면 문이 없다(머리말). 무시했다는 사실은 반드시 남긴다 - 안 먹은 값을 먹은 줄 알면 검증이 거짓이 된다.
  if (!resolveDevTools(search)) {
    console.warn(`[main] ?${DATE_QUERY_KEY}=${raw} 무시됨 - ?${DEV_QUERY_KEY}=1과 함께여야 한다(저장을 건드리는 손잡이다).`)
    return null
  }

  const value = raw.trim()
  if (!isDateKey(value)) {
    console.warn(`[main] ?${DATE_QUERY_KEY}=${raw} 무시됨 - YYYY-MM-DD 꼴의 실재하는 날짜여야 한다.`)
    return null
  }

  return value
}

/**
 * `?pull=3` → 3. 없거나 잘못된 값이면 `null`(= 재현 아님).
 *
 * 1 이상의 정수만 - 봉투 회차는 1부터 센다(`economy/envelope.ts`). 상한은 없다. 이력 밖의 회차도
 * 바늘 값은 정확하므로 어떤 값이 와도 결정론이 깨지지 않는다(`resolveAttempt`와 같은 계열의 재현 도구).
 */
export function resolvePullSeq(search: string): number | null {
  const raw = new URLSearchParams(search).get(PULL_QUERY_KEY)
  if (raw === null) return null

  const value = Number(raw.trim())
  if (raw.trim() === '' || !Number.isSafeInteger(value) || value < 1) {
    console.warn(`[main] ?${PULL_QUERY_KEY}=${raw} 무시됨 - 1 이상의 정수여야 한다.`)
    return null
  }

  return value
}

function isBotDifficulty(value: string): value is BotDifficulty {
  return (BOT_DIFFICULTIES as readonly string[]).includes(value)
}

/**
 * `?match=bots` → 봇 판 요청. 없으면 `null`(= 봇 판 아님).
 *
 * `?bots=`·`?botLevel=`은 잘못되면 **기본값으로 떨어지되 반드시 남긴다**(`tuning.ts`의 규약) - 문 자체(`?match=bots`)는 열어 준다.
 * 오타 하나로 판이 안 서면 도구가 아니고, 조용히 삼키면 봇 7명인 줄 알고 3명을 상대한 기록이 남는다.
 * `?match=`의 값이 `bots`가 아니면 문이 아니다 - 경고를 남기고 `null`.
 */
export function resolveBotMatch(search: string): BotMatchRequest | null {
  const params = new URLSearchParams(search)
  const match = params.get(MATCH_QUERY_KEY)
  if (match === null) return null
  if (match.trim() !== MATCH_BOTS) {
    console.warn(`[main] ?${MATCH_QUERY_KEY}=${match} 무시됨 - 지금 있는 문은 '${MATCH_BOTS}' 하나다.`)
    return null
  }

  let bots = DEFAULT_PARTY_BOTS
  const rawBots = params.get(BOTS_QUERY_KEY)
  if (rawBots !== null) {
    const value = Number(rawBots.trim())
    if (rawBots.trim() !== '' && Number.isInteger(value) && value >= 1 && value <= MAX_PARTY_BOTS) bots = value
    else console.warn(`[main] ?${BOTS_QUERY_KEY}=${rawBots} 무시됨 - 1~${String(MAX_PARTY_BOTS)}의 정수여야 한다. 기본 ${String(DEFAULT_PARTY_BOTS)}.`)
  }

  let botLevel = DEFAULT_BOT_LEVEL
  const rawLevel = params.get(BOT_LEVEL_QUERY_KEY)
  if (rawLevel !== null) {
    const value = rawLevel.trim()
    if (isBotDifficulty(value)) botLevel = value
    else console.warn(`[main] ?${BOT_LEVEL_QUERY_KEY}=${rawLevel} 무시됨 - ${BOT_DIFFICULTIES.join(' · ')} 중 하나여야 한다. 기본 ${DEFAULT_BOT_LEVEL}.`)
  }

  if (params.get(LEGACY_CHANGER_QUERY_KEY) !== null) {
    console.warn(`[main] ?${LEGACY_CHANGER_QUERY_KEY}= 무시됨 - 이제 전원이 자기 구획을 고친다(로드맵 M11).`)
  }

  return { seed: resolveFreeModeSeed(search) ?? DEFAULT_SEED, bots, botLevel }
}

/**
 * `?room=abcd` → `ABCD`. 없으면 `null`(= 방 직행 아님).
 *
 * 대문자로 다듬는다 - 폰에서 받아 적은 번호는 소문자로 들어오기 쉽고, 그것으로 "그 번호의 방이 없다"를 받으면 사람은 번호를 의심한다.
 * 길이가 다르거나 글자가 아니면 **무시하되 남긴다**(`tuning.ts`의 규약) - 문은 로비 폼으로 열어 주는 쪽이 낫지만, 이 함수가 `null`을
 * 돌려주면 `main.ts`는 평범한 첫 화면으로 간다(서버에 없는 번호를 자동으로 두드리지 않는다).
 */
export function resolveRoomCode(search: string): string | null {
  const raw = new URLSearchParams(search).get(ROOM_QUERY_KEY)
  if (raw === null) return null

  const code = normalizeRoomCode(raw)
  if (!isRoomCode(code)) {
    console.warn(`[main] ?${ROOM_QUERY_KEY}=${raw} 무시됨 - ${String(ROOM_CODE_LENGTH)}글자의 방 번호가 아니다(I·O·0·1은 쓰지 않는다).`)
    return null
  }
  return code
}

/* --- 쓰기 --------------------------------------------------------------------- */

/** 히스토리를 쌓지 않고 주소창만 바꾼다. 같은 주소면 아무 일도 하지 않는다. */
function replaceLocation(url: URL): void {
  if (url.href === window.location.href) return
  window.history.replaceState(null, '', url)
}

/**
 * 주소창을 지금 있는 곳으로 갈아 끼운다.
 *
 * 이게 없으면 재현 가능한 유일한 판은 첫 판뿐이고, 시드 결정론을 지킨 의미가 절반 사라진다.
 * 단계와 시드는 **서로를 지운다** - 둘 다 남아 있으면 새로고침했을 때 어느 쪽이 이기는지
 * URL만 봐서는 알 수 없다. 그래서 두 함수를 각자 열지 않고 이 한 자리를 통과시킨다.
 */
function writeExclusiveQuery(key: typeof SEED_QUERY_KEY | typeof LEVEL_QUERY_KEY, value: string): void {
  const url = new URL(window.location.href)
  url.searchParams.delete(key === SEED_QUERY_KEY ? LEVEL_QUERY_KEY : SEED_QUERY_KEY)
  // 봇 판의 셋도 "어느 판인가"다. 단계·자유 모드가 서면 지운다 - 남으면 새로고침이 봇 판으로 돌아간다.
  deleteMatchKeys(url)
  url.searchParams.set(key, value)
  replaceLocation(url)
}

/** 여럿이 키 전부 - 봇 판의 셋과 방 번호. 어느 판이든 "어느 판인가"는 하나여야 한다. */
function deleteMatchKeys(url: URL): void {
  url.searchParams.delete(MATCH_QUERY_KEY)
  url.searchParams.delete(BOTS_QUERY_KEY)
  url.searchParams.delete(BOT_LEVEL_QUERY_KEY)
  url.searchParams.delete(LEGACY_CHANGER_QUERY_KEY)
  url.searchParams.delete(ROOM_QUERY_KEY)
}

/**
 * 지금 앉은 여럿이 방을 주소창에 남긴다(로드맵 M6). 단계·시드·시도·봇 판은 함께 지워진다 - 방 번호 하나가 판을 가리킨다.
 * 새로고침이 이 주소로 돌아와 좌석 기억(`app/netBoot.ts`)과 만나면 "자리로 돌아왔다"가 된다. 공유용이기도 하다 - 이 주소를 그대로
 * 보내면 상대가 같은 방의 로비에 선다.
 */
export function writeRoomQuery(roomCode: string): void {
  const url = new URL(window.location.href)
  url.searchParams.delete(LEVEL_QUERY_KEY)
  url.searchParams.delete(SEED_QUERY_KEY)
  url.searchParams.delete(ATTEMPT_QUERY_KEY)
  deleteMatchKeys(url)
  url.searchParams.set(ROOM_QUERY_KEY, roomCode)
  replaceLocation(url)
}

/**
 * 지금 도는 봇 판을 주소창에 남긴다. 단계·시도는 함께 지워진다(봇 판에는 시도 번호가 없다 - `main.startBotMatch`).
 *
 * 시드와 봇 셋을 **한 번에** 적는다. 갈라 적으면 그 사이의 주소(`?seed=x`만 있는)가 자유 모드를 가리키는 순간이 생기고,
 * 그 순간에 새로고침하면 다른 판이 선다. 기본값과 같은 값도 적는다 - 이 주소는 공유용이 아니라 재현용이고, 봇 수가
 * 기본이라는 사실을 읽는 사람이 기본값을 외우고 있어야 한다면 그건 재현이 아니다.
 */
export function writeMatchQuery(request: BotMatchRequest): void {
  const url = new URL(window.location.href)
  url.searchParams.delete(LEVEL_QUERY_KEY)
  url.searchParams.delete(ATTEMPT_QUERY_KEY)
  // 소켓 방 번호도 지운다 - "어느 판인가"는 하나여야 한다(`deleteMatchKeys` 주석). 남으면 주소가 두 판을 가리킨다.
  url.searchParams.delete(ROOM_QUERY_KEY)
  url.searchParams.set(SEED_QUERY_KEY, request.seed)
  url.searchParams.set(MATCH_QUERY_KEY, MATCH_BOTS)
  url.searchParams.set(BOTS_QUERY_KEY, String(request.bots))
  url.searchParams.set(BOT_LEVEL_QUERY_KEY, request.botLevel)
  // 옛 `?changer=`는 뜻이 없어졌다(M11) - 남아 있으면 지운다.
  url.searchParams.delete(LEGACY_CHANGER_QUERY_KEY)
  replaceLocation(url)
}

/** 지금 도는 단계를 주소창에 남긴다. 자유 모드 시드는 함께 지워진다. */
export function writeLevelQuery(levelId: number): void {
  writeExclusiveQuery(LEVEL_QUERY_KEY, String(levelId))
}

/** 지금 도는 자유 모드 시드를 주소창에 남긴다. 단계는 함께 지워진다. */
export function writeSeedQuery(seed: string): void {
  writeExclusiveQuery(SEED_QUERY_KEY, seed)
}

/**
 * 시도 번호를 주소창에 남긴다. **단계·시드를 지우지 않는다** -
 * 시도 번호는 그 둘과 배타적이지 않고 오히려 짝을 이룬다(`?level=3&attempt=2`).
 *
 * 첫 시도면 아예 지운다. `attempt=0`은 기본값이라 적어 봐야 주소만 길어지고,
 * 그 길이가 "공유할 수 있는 링크"라는 성질을 조금씩 깎는다.
 */
export function writeAttemptQuery(attempt: number): void {
  const url = new URL(window.location.href)
  if (attempt <= FIRST_ATTEMPT) url.searchParams.delete(ATTEMPT_QUERY_KEY)
  else url.searchParams.set(ATTEMPT_QUERY_KEY, String(attempt))
  replaceLocation(url)
}

/** 단계 선택은 어느 판도 아니다. 주소에 남은 단계·시드·시도·봇 판·방 번호를 함께 지운다. */
export function clearLocationQuery(): void {
  const url = new URL(window.location.href)
  url.searchParams.delete(SEED_QUERY_KEY)
  url.searchParams.delete(LEVEL_QUERY_KEY)
  url.searchParams.delete(ATTEMPT_QUERY_KEY)
  deleteMatchKeys(url)
  replaceLocation(url)
}
